"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_SIGN_IN_ACTIVITY = exports.ACTIVITY_COMPLETED = exports.RESET = exports.RESET_ACTIVITY = exports.SUBMIT_CODE = exports.GET_SELECTED_ACTIVITY = exports.GET_ACTIVITY_FEATURED = exports.GET_BONUS_ACTIVITY = exports.GET_HOME_ACTIVITY_LIST_V2 = exports.GET_ACTIVITY_LIST_V2 = exports.DISMISS_DAILY_BONUS = exports.GET_ACTIVITY_WITH_FREQ_CAP = exports.CREDIT = exports.GET_ACTIVITY = exports.HistoryType = exports.ActivityType = exports.ActivityState = exports.MobileOpenLink = void 0;
var MobileOpenLink;
(function (MobileOpenLink) {
    MobileOpenLink["IN_BROWSER"] = "IN_BROWSER";
    MobileOpenLink["IN_APP"] = "IN_APP";
})(MobileOpenLink || (exports.MobileOpenLink = MobileOpenLink = {}));
var ActivityState;
(function (ActivityState) {
    ActivityState[ActivityState["DRAFT"] = 1] = "DRAFT";
    ActivityState[ActivityState["PUBLISHED"] = 2] = "PUBLISHED";
    ActivityState[ActivityState["ACTIVE"] = 3] = "ACTIVE";
    ActivityState[ActivityState["FINISHED"] = 4] = "FINISHED";
    ActivityState[ActivityState["ARCHIVED"] = 5] = "ARCHIVED";
})(ActivityState || (exports.ActivityState = ActivityState = {}));
var ActivityType;
(function (ActivityType) {
    ActivityType["CODE_REDEMPTION"] = "CODE_REDEMPTION";
    ActivityType["GENERIC"] = "GENERIC";
    ActivityType["INTERACTIVE_GAME"] = "INTERACTIVE_GAME";
    ActivityType["INVITE_FRIEND"] = "INVITE_FRIEND";
    ActivityType["POLL"] = "POLL";
    ActivityType["SURVEY"] = "SURVEY";
    ActivityType["QUIZ"] = "QUIZ";
    ActivityType["TICKET_ENTRY"] = "TICKET_ENTRY";
    ActivityType["UPLOAD_CONTENT"] = "UPLOAD_CONTENT";
    ActivityType["VIEW_URL"] = "VIEW_URL";
    ActivityType["STANDARD_ACTIVITY"] = "STANDARD";
    ActivityType["WINNINGS"] = "WINNINGS";
    ActivityType["COLLECT_ALL"] = "COLLECT_ALL";
})(ActivityType || (exports.ActivityType = ActivityType = {}));
var HistoryType;
(function (HistoryType) {
    HistoryType["POINTS_TO_TOKENS"] = "POINTS_TO_TOKENS";
    HistoryType["TOKENS_PURCHASE"] = "TOKENS_PURCHASE";
    HistoryType["GAMEPLAY"] = "GAMEPLAY";
    HistoryType["WINNINGS"] = "WINNINGS";
    HistoryType["SWEEPSTAKES_ENTRIES"] = "SWEEPSTAKES_ENTRIES";
    HistoryType["FREE_DAILY"] = "FREE_DAILY";
    HistoryType["OTHER"] = "OTHER";
})(HistoryType || (exports.HistoryType = HistoryType = {}));
exports.GET_ACTIVITY = 'activity/GET_ACTIVITY';
exports.CREDIT = 'activity/CREDIT';
exports.GET_ACTIVITY_WITH_FREQ_CAP = 'activity/GET_ACTIVITY_WITH_FREQ_CAP';
exports.DISMISS_DAILY_BONUS = 'activity/DISMISS_DAILY_BONUS';
exports.GET_ACTIVITY_LIST_V2 = 'activity/GET_ACTIVITY_LIST_V2';
exports.GET_HOME_ACTIVITY_LIST_V2 = 'activity/GET_HOME_ACTIVITY_LIST_V2';
exports.GET_BONUS_ACTIVITY = 'activity/GET_BONUS_ACTIVITY';
exports.GET_ACTIVITY_FEATURED = 'activity/GET_ACTIVITY_FEATURED';
exports.GET_SELECTED_ACTIVITY = 'activity/GET_SELECTED_ACTIVITY';
exports.SUBMIT_CODE = 'activity/SUBMIT_CODE';
exports.RESET_ACTIVITY = 'activity/RESET_ACTIVITY';
exports.RESET = 'activity/RESET';
exports.ACTIVITY_COMPLETED = 'activity/ACTIVITY_COMPLETED';
exports.GET_SIGN_IN_ACTIVITY = 'activity/GET_SIGN_IN_ACTIVITY';
//# sourceMappingURL=types.js.map